import OptimizeApi from '../api/optimize';
import { publicFun } from './common';
class OptimizeEntities {
    constructor() {
        this.api = new OptimizeApi();
    }
    /**获取机构（供货、要货、管辖机构等） */
    getOrganiztion(params) {
        return publicFun(this.api.getOrganiztion, params)
    }

    /**供货机构（供应商）下拉框 - 加载数据  */
    getSublevel(params) {
        return publicFun(this.api.getSublevel, params)
    }

    /**仓库下拉框 - 加载数据 */
    getwarehouse(params) {
        return publicFun(this.api.getwarehouse, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getCategory(params) {
        return publicFun(this.api.getCategory, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getBumen(params) {
        return publicFun(this.api.getBumen, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getBiaoqian(params) {
        return publicFun(this.api.getBiaoqian, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getYuanyin(params) {
        return publicFun(this.api.getYuanyin, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getWupin(params) {
        return publicFun(this.api.getWupin, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getCaipin(params) {
        return publicFun(this.api.getCaipin, params)
    }
    /**类别下拉框或树节点分段加载 - 加载数据  */
    getWaixiaokehu(params) {
        return publicFun(this.api.getWaixiaokehu, params)
    }
    getItems(params, type) {
        params._type = type
        return publicFun(this.api.getItems, params)
    }
}

export default OptimizeEntities;


// WEBPACK FOOTER //
// ./src/logics/entities/optimize.js